import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductGroupUpsertState extends ApiState {
  productGroupId?: string
}

export default requestReducer<ProductGroupUpsertState>('PRODUCTGROUP_UPSERT')
